<template>
    <div class="row">
        <div class="col-md-7">
            <form @submit.prevent="validateForm">
                <div class="form-group required">
                    <label>Benefit Commencement Date</label>
                    <input ref="inputBenefitCommencementDate" name="inputBenefitCommencementDate" data-vv-as="benefit commencement date" v-model="benefitCommencementDate" type="text" class="form-control" data-vv-validate-on="blur" v-validate="'required|date_format:DD/MM/YYYY'" :class="{
                        'is-invalid':  validationErrors.has('inputBenefitCommencementDate')
                    }" >
                    <div v-show="validationErrors.has('inputBenefitCommencementDate')" class="invalid-feedback">
                        {{ validationErrors.first('inputBenefitCommencementDate') }}
                    </div>
                    <small>
                        The date which employee benefits start after company registration.
                    </small>
                </div>
                <div class="form-group required">
                    <label>Benefit Refresh Date</label>
                    <!-- <input ref="inputBenefitRefreshDate" name="inputBenefitRefreshDate" data-vv-as="benefit refresh date" v-model="benefitRefreshDate" type="text" class="form-control" data-vv-validate-on="blur" v-validate="'required|date_format:DD/MM/YYYY'" :class="{
                        'is-invalid':  validationErrors.has('inputBenefitRefreshDate')
                    }" > -->
                    <div class="row ml-0 mr-0">
                        <select name="inputBenefitRefreshDay" data-vv-validate-on="blur|input" data-vv-as="benefit refresh date"
                            v-validate="dateValidation" v-model="benefitRefreshDay" ref="benefitRefreshDay" :class="{
                            'form-control': true,
                            'col-4': true,
                            'is-invalid':  validationErrors.has('inputBenefitRefreshDay')
                        }">
                            <option value="01">1</option>
                            <option value="02">2</option>
                            <option value="03">3</option>
                            <option value="04">4</option>
                            <option value="05">5</option>
                            <option value="06">6</option>
                            <option value="07">7</option>
                            <option value="08">8</option>
                            <option value="09">9</option>
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>
                            <option value="13">13</option>
                            <option value="14">14</option>
                            <option value="15">15</option>
                            <option value="16">16</option>
                            <option value="17">17</option>
                            <option value="18">18</option>
                            <option value="19">19</option>
                            <option value="20">20</option>
                            <option value="21">21</option>
                            <option value="22">22</option>
                            <option value="23">23</option>
                            <option value="24">24</option>
                            <option value="25">25</option>
                            <option value="26">26</option>
                            <option value="27">27</option>
                            <option value="28">28</option>
                            <option value="29" v-if="benefitRefreshMonth!=='02'">29</option>
                            <option value="30" v-if="benefitRefreshMonth!=='02'">30</option>
                            <option value="31" v-if="!monthsWith30Days.includes(benefitRefreshMonth) && benefitRefreshMonth!= 2">31</option>
                        </select>
                        <select name="inputBenefitRefreshMonth" v-model="benefitRefreshMonth" @input="revalidateRefreshDate" :class="{
                            'form-control': true,
                            'col-8': true,
                            'is-invalid':  validationErrors.has('inputBenefitRefreshDay')
                        }">
                            <option value="01">January</option>
                            <option value="02">February</option>
                            <option value="03">March</option>
                            <option value="04">April</option>
                            <option value="05">May</option>
                            <option value="06">June</option>
                            <option value="07">July</option>
                            <option value="08">August</option>
                            <option value="09">September</option>
                            <option value="10">October</option>
                            <option value="11">November</option>
                            <option value="12">December</option>
                        </select>
                        <div v-show="validationErrors.has('inputBenefitRefreshDay')" class="invalid-feedback">
                            {{ validationErrors.first('inputBenefitRefreshDay') }}
                        </div>
                    </div>
                    <small>
                        The anniversary date which employee benefits' annual limit, etc are refreshed to original set amounts on every calendar year. Auto refreshing on subsequent years, unless HR keys in new date.
                    </small>
                </div>
                <div>
                    <p>{{ updateMessage }}</p>
                    <button type="button" class="btn btn-primary btn-primary-insv mr-2" @click="saveChanges">Save Changes</button>
                    <button type="button" class="btn btn-secondary" @click="getBenefitDateSettings">Discard Changes</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {
    convertDateToDDMMYYYY,
    convertDateToIso8601
} from '@/utilities';
import $ from 'jquery';
import 'daterangepicker/daterangepicker';
export default {
    'name': 'CompanyBenefitDates',
    data () {
        return {
            'benefitCommencementDate': null,
            'benefitRefreshDate': null,
            'updateMessage': null,
            'benefitRefreshDay': null,
            'benefitRefreshMonth': null
        };
    },
    'computed': {
        dateValidation () {
            let maxDay = '31';
            if (this.monthsWith30Days.includes(this.benefitRefreshMonth)) {
                maxDay = '30';
            } else if (this.benefitRefreshMonth === '02') {
                maxDay = '28';
            }

            let result = `required|between:1,${maxDay}`;
            return result;
        },
        monthsWith30Days () {
            return [
                '04', '06', '09', '11'
            ];
        }
    },
    mounted () {
        this.getBenefitDateSettings();

        this.initializeDatePickers();
    },
    'methods': {
        validateForm () {
            return this.$validator.validateAll();
        },
        getBenefitDateSettings () {
            this.axios.get('Company/GetBenefitDateSettings').then(({
                data
            }) => {
                let companyData = data.data;

                if (companyData != null) {
                    this.benefitCommencementDate = companyData.benefitCommencementDate ? convertDateToDDMMYYYY(companyData.benefitCommencementDate) : null;
                    this.benefitRefreshDate = companyData.benefitRefreshDate ? convertDateToDDMMYYYY(companyData.benefitRefreshDate) : null;
                    this.benefitRefreshDay = companyData.benefitRefreshDate ? convertDateToDDMMYYYY(companyData.benefitRefreshDate).split('/')[0] : null;
                    this.benefitRefreshMonth = companyData.benefitRefreshDate ? convertDateToDDMMYYYY(companyData.benefitRefreshDate).split('/')[1] : null;
                }
            });
        },
        initializeDatePickers () {
            $(this.$refs.inputBenefitCommencementDate).daterangepicker({
                'singleDatePicker': true,
                'autoApply': true,
                'locale': {
                    'format': 'DD/MM/YYYY'
                }
            });

            $(this.$refs.inputBenefitCommencementDate).on(
                'apply.daterangepicker',
                (ev, picker) => {
                    this.benefitCommencementDate = picker.startDate.format('DD/MM/YYYY');
                }
            );

            // $(this.$refs.inputBenefitRefreshDate).daterangepicker({
            //     'singleDatePicker': true,
            //     'autoApply': true,
            //     'locale': {
            //         'format': 'DD/MM/YYYY'
            //     }
            // });

            // $(this.$refs.inputBenefitRefreshDate).on(
            //     'apply.daterangepicker',
            //     (ev, picker) => {
            //         this.benefitRefreshDate = picker.startDate.format('DD/MM/YYYY');
            //     }
            // );
        },
        revalidateRefreshDate () {
            this.benefitRefreshDay = this.benefitRefreshDay;
        },
        saveChanges () {
            this.validateForm().then((isValid) => {
                if (isValid) {
                    this.updateMessage = 'Updating benefit date settings...';
                    this.axios.post('Company/UpdateBenefitDateSettings', {
                        'benefitCommencementDate': convertDateToIso8601(this.benefitCommencementDate),
                        'benefitRefreshDate': convertDateToIso8601(`${this.benefitRefreshDay}/${this.benefitRefreshMonth}/${new Date().getFullYear()}`)
                    }).then(() => {
                        this.updateMessage = 'Benefit date settings updated successfully!';
                    }).catch(() => {
                        this.updateMessage = 'Error updating benefit date settings. Please try again.';
                    });
                }
            });
        }
    }
};
</script>
